import React, { useEffect } from 'react';

import SignInPage from './Auth/SignInPage';

const ThirdPartySignIn = () => {
  useEffect(() => {
    document.body.classList.add('auth-bg');
    return () => {
      document.body.classList.remove('auth-bg');
    };
  }, []);

  return <SignInPage isThirdParty />;
};

export default ThirdPartySignIn;
